// Angular
// tslint:disable-next-line:whitespace

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Models
import { Attachment } from './../../models/attachment';
// External
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { FirebaseApp } from 'angularfire2';
import * as moment from 'moment';
import * as lodash from 'lodash';
import { OAuthService } from './../../services/o-auth';
import { ActivatedRoute } from '@angular/router';

import { ApiService } from './../../services/api';
import { Subject } from "rxjs";

@Component({
    templateUrl: './update.league.component.html'
})
export class UpdateLeagueComponent implements OnInit {
    public league: any
    private attachment: Attachment;
    private attachmentExt: string;
    private orginalAttachment: Attachment;
    public imageLoader = false
    public leagueId: String
    public parentSubject: Subject<any> = new Subject();

    public selectedTournaments: Array<any>
    constructor(private router: Router, private firebase: FirebaseApp, private apiService: ApiService, private route: ActivatedRoute,
        private fireAuth: AngularFireAuth, private fireDatabase: AngularFireDatabase, private oAuthService: OAuthService) {
        this.leagueId = this.route.snapshot.paramMap.get('id');

        this.league = {
            name: "",
            image: "",
            description: "",
            status: 1
        }
    }
    async ngOnInit() {


        this.apiService.object("leagues/" + this.leagueId).then(async (res) => {
            this.league = res
            this.league.selectedTournaments = []
            for (let i = 0; i < Object.keys(this.league.tournaments).length; i++) {
                const t_id = Object.keys(this.league.tournaments)[i];
                this.league.selectedTournaments.push(await this.getTournament(t_id));

            }
            this.parentSubject.next(this.league);

        })
    }

    async getTournament(uid) {
        let promise = new Promise((resolve, reject) => {
            if (typeof uid == "string") {
                this.apiService.object("tournaments/" + uid).then(result => {
                    result.key = uid;
                    resolve(result);
                });
            }
        });
        return promise;
    }
    changeAttachment(attachment: Attachment): void {
        if (attachment) {
            if (attachment.isOriginal) {
                this.orginalAttachment = attachment
            } else {
                this.attachment = attachment;

            }
            this.attachmentExt = attachment.file.name.split('.').pop();


        } else {
            this.attachmentExt = '';
        }
    }
    private uploadFile(): Promise<any> {
        var newImage = new Promise((resolve, reject) => {
            if (this.attachment) {
                const filename = `${moment().unix()}.${this.attachmentExt}`;
                this.firebase.storage().ref(`/leagues/${this.fireAuth.auth.currentUser.uid}`).child(filename)
                    .put(this.attachment.file)
                    .then(result => resolve(result))
                    .catch(error => reject(error));
            } else {
                return resolve();
            }
        });
        var OriginalImage = new Promise((resolve, reject) => {
            if (this.attachment) {
                const filename = `${moment().unix()}.${Math.floor(Math.random() * (900) + 100)}.${this.attachmentExt}`;
                this.firebase.storage().ref(`/leagues/${this.fireAuth.auth.currentUser.uid}`).child(filename)
                    .put(this.orginalAttachment.file)
                    .then(result => resolve(result))
                    .catch(error => reject(error));
            } else {
                return resolve();
            }
        });
        return Promise.all([newImage, OriginalImage])
    }
    changeClub(club: any) {
        this.selectedTournaments = club
        console.log(this.selectedTournaments)
    }
    remove() {
        this.league.image = null
        this.league.originalImage= null
    }
    public addLeague() {
        this.imageLoader = true
        this.league.created = new Date().getTime() / 1000
        this.uploadFile()
            .then(fileResult => {

                if (fileResult[0] && fileResult[0].downloadURL) {
                    this.league.image = fileResult[0].downloadURL
                }
                if (fileResult[1] && fileResult[1].downloadURL) {
                    this.league.originalImage = fileResult[1].downloadURL
                }
                this.league.tournaments = {}
                for (let i = 0; i < this.selectedTournaments.length; i++) {
                    const element = this.selectedTournaments[i];
                    this.league.tournaments[element.$key] = element.eventName
                }

                this.apiService.set("leagues/" + this.leagueId, this.league).then((res) => {
                    this.imageLoader = false
                    return this.router.navigate(['/components/leagues']);
                })
            })

    }

}



